// https://vuex.vuejs.org/en/actions.html

import NewApiService from "@/utils/new.api.service";

export default {
  index(context, params) {
    const { sortBy, descending, page, rowsPerPage } = params.pagination
      ? params.pagination
      : [null, null, null, null];
    context.commit("set_loading");
    return new Promise(resolve => {
      NewApiService.get("shop", {
        page: page,
        sortBy: sortBy,
        descending: descending,
        rowsPerPage: rowsPerPage,
        search: params.search
      })
        .then(({ data }) => {
          context.commit("set_shops", data.shops);
          context.commit("unset_loading");
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit("set_error", response.data.errors);
        });
    });
  },
  view(context, params) {
    context.commit("set_loading");
    return new Promise(resolve => {
      NewApiService.get("shop/" + params.id, {})
        .then(({ data }) => {
          context.commit("unset_loading");
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit("set_error", response.data.errors);
        });
    });
  },
  list(context) {
    context.commit("set_loading");
    return new Promise(resolve => {
      NewApiService.get("shop")
        .then(({ data }) => {
          context.commit("set_shops", data.shops);
          context.commit("unset_loading");
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit("set_error", response.data.errors);
        });
    });
  },
  add(context, params) {
    context.commit("set_loading");
    return new Promise((resolve, reject) => {
      NewApiService.post("shop", params.model)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit("set_error", response.data.errors);
          reject(response)
        })
        .finally(()=>{
          context.commit("unset_loading");
        });
    });
  },
  update(context, params) {
    context.commit("set_loading");
    return new Promise((resolve, reject) => {
      NewApiService.put("shop/" + params.model.id, params.model)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit("set_error", response.data.errors);
          reject(response);
        })
        .finally(()=>{
          context.commit("unset_loading");
        });
    });
  },
  delete(context, params) {
    context.commit("set_loading");
    return new Promise((resolve, reject) => {
      NewApiService.delete("shop/" + params.model.id)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        })
        .finally(() => {
          context.commit("unset_loading");
        })
    });
  }
};
